import React from "react";
import styled from "styled-components";
import { useField } from "formik";

// assets
import Camera from "assets/icons/camera_icon.svg";
import DeleteIcon from "assets/icons/delete_icon.svg";

const ImagePicker = ({
  label,
  uploadLimit,
  setDeletedImages,
  setDirty,
  ...props
}) => {
  const [field, meta, { setValue }] = useField(props);
  const disabled = field.value.length > uploadLimit - 1;

  const renderImages = () => {
    const renderMap = field.value || [];
    return renderMap.map((image, index) => {
      const url = image.url ? image.url : URL.createObjectURL(image);
      return (
        <SingleImage key={index}>
          <Delete src={DeleteIcon} onClick={() => onRemove(image)} />
          <img src={url} />
        </SingleImage>
      );
    });
  };

  const onAdd = (newImage) => {
    const currentImages = field.value;

    if (newImage) {
      const imageFound = currentImages.find(
        (image) => image.name === newImage.name
      );
      if (imageFound) {
        return null;
      } else {
        currentImages.unshift(newImage);
        setValue(currentImages);
        setDirty(true);
      }
    } else {
      return null;
    }
  };

  const onRemove = (image) => {
    const currentImages = field.value;

    if (image.hasOwnProperty("id") && image.hasOwnProperty("url")) {
      const foundIndex = currentImages.findIndex(
        (item) => item.id === image.id
      );
      currentImages.splice(foundIndex, 1);
      setValue(currentImages);
      setDeletedImages((state) => [...state, image.id]);
    } else {
      const foundIndex = currentImages.findIndex(
        (item) => item.name === image.name
      );
      currentImages.splice(foundIndex, 1);
      setValue(currentImages);
    }
  };

  return (
    <Wrapper>
      {label && <Label>{label}</Label>}

      <ImagesWrapper>
        <div>
          <ImageInputButton htmlFor={field.name} disabled={disabled}>
            <img src={Camera} />
            <span>{`${field.value.length || 0}/${uploadLimit}`}</span>
            <input
              multiple={false}
              type="file"
              id={field.name}
              accept="image/*"
              hidden
              onChange={(e) => {
                if (e.target?.files[0]?.size === 0) return;
                onAdd(e.target.files[0]);
              }}
              onClick={(e) => (e.target.value = null)}
              disabled={disabled}
            />
          </ImageInputButton>
        </div>

        {renderImages()}
      </ImagesWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  margin-bottom: 16px;
`;

const ImagesWrapper = styled.div`
  padding-top: 6px;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: auto;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  ::-webkit-scrollbar {
    display: none;
  }
`;

const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: ${(props) => props.theme.colors.inputLabel};
  margin-bottom: 2px;
  line-height: 18px;
`;

const ImageInputButton = styled.label`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 72px;
  background-color: #eef1f9;
  border-radius: 6px;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};

  span {
    font-size: 12px;
    line-height: 16px;
    color: #838791;
    margin-top: 4px;
    font-feature-settings: "tnum" on, "lnum" on;
  }
`;

const SingleImage = styled.div`
  position: relative;
  display: block;
  width: 80px;
  height: 72px;
  min-width: 80px;
  margin-left: 8px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
  }
`;

const Delete = styled.span`
  display: block;
  position: absolute;
  width: 16px;
  height: 16px;
  top: -5px;
  right: -4px;
  font-size: 0;
  background: url(${(props) => props.src}) no-repeat center;
  &:hover {
    cursor: pointer;
  }
`;

export default ImagePicker;
